module.exports = __webpack_public_path__ + "img/engagement_8.7da799ee.jpg";